import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSettingParams } from '../../../common/filterCompany/useSettingParams'
import { Panel } from '../../../common/panel'
import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../common/selectCurrencyUnit/useFormatCurrency'
import { HIGH_LIGHT_TITLE } from '../constants'
import withLoadingFeedBack from '../hoc/withLoadingFeedback'
import BaseContainer from './BaseContainer'
import { selectLoading, selectSegmentScoreBusinessSize } from './store/slice'
import { exportBusinessSize, getBusinessSize } from './store/thunk'

export const DEFAULT_CHART_HIGHT = 200

const BusinessSize = () => {
  const dispatch = useDispatch()
  const settingParams = useSettingParams()

  const data = useSelector(selectSegmentScoreBusinessSize())
  const isLoading = useSelector(selectLoading)
  const locale = useSelector((state) => state.i18n.locale)
  const { currency } = useFormatCurrency(SCREEN.PORTFOLIO_INSIGHTS)

  const Container = withLoadingFeedBack(
    isLoading,
    data,
    DEFAULT_CHART_HIGHT,
  )(BaseContainer)

  useEffect(() => {
    if (!settingParams) return
    dispatch(
      getBusinessSize({
        ...settingParams,
        currency,
      }),
    )
  }, [settingParams, locale, currency])

  return (
    <Panel
      label="portfolio.segment.BUSINESS_SIZE_BY_REVENUE"
      isI18n={true}
      downloadCsv={{ downloadFunc: () => exportBusinessSize(settingParams) }}
      className={HIGH_LIGHT_TITLE.mostPopularBusinessSize}
    >
      <Container />
    </Panel>
  )
}

export default BusinessSize
